import { memo } from 'react';
import cn from 'classnames';
import { SkuExtended } from 'types/sku.types';
import styles from './serviceprice.module.scss';

type ServicePriceMemberProps = {
  sku: SkuExtended;
  className?: string;
  sm?: boolean;
  showFixedPrice?: boolean;
  typeClasses?: string;
  classes?: string;
};

const ServicePriceMember = ({ sku, sm, showFixedPrice = false, typeClasses, classes }: ServicePriceMemberProps) => {
  const baseStyles = cn({ p0: !sm, p1: sm, nowrap: true });
  const badgeStyles = cn(styles.badge, { [styles.sm]: sm });

  return (
    <div className={classes}>
      <span className={baseStyles}>
        {!showFixedPrice && <span className={typeClasses}>Starting at</span>} <span className={styles.old}>{sku.prices.price}</span>{' '}
        <span className={cn(baseStyles, 'text-weight-medium lightBlue')}>{sku.prices.memberPrice}</span>
      </span>
      <span className={badgeStyles}>Member Price</span>
    </div>
  );
};

export default memo(ServicePriceMember);
